<script>
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	const GIVE_CLUE = 'giveClue';
	const CREATE_GAME = 'createGame';
	const REMATCH = 'rematch';
	const CANCEL_REMATCH = 'cancelRematch';
	const END_GUESSING = 'endGuessing';
	const FORCE_END_TURN = 'forceEndTurn';

	export let clue;
	export let clueNumber;
	export let team;
	export let showForm;
	export let gameOver;
	export let isGuessing;
	export let isLoading;
	export let isJoinedPlayer;
	export let numPlayersClickedRematch;
	export let authPlayerClickedRematch;
	export let numPlayers;
	export let showForceEndTurn;

	let clueText = '';

	$: if (!isLoading) {
		clueText = '';
	}

	$: isClueDisabled = !clueText.toString().trim().length || clueNumber === '' || clueNumber === undefined || clueNumber === null;

	/*
	function onlyAllowNumberOnKeyDown(e) {
		if(e.shiftKey ||
			!(
				e.keyCode == 8 ||							// backspace
				e.keyCode == 46 ||							// delete
				(e.keyCode >= 35 && e.keyCode <= 40) ||		// arrow keys/home/end
				(e.keyCode >= 48 && e.keyCode <= 57) ||		// numbers on keyboard
				(e.keyCode >= 96 && e.keyCode <= 105)		// number on keypad
			)
		) {
			e.preventDefault();
		}
	}
	*/

	let clueNumberConfirmationNeeded = false;

	$: numClickedRematchText = `${numPlayersClickedRematch} of ${numPlayers} players clicked rematch`;
</script>

{#if gameOver}
	<div class={`clue-display ${team} form`}>
		{#if isJoinedPlayer}
			{#if !authPlayerClickedRematch}
				<button
					type="submit"
					class="clue-submit"
					class:colorcycle={isLoading}
					title="Start a new game"
					on:click={() => !isLoading && dispatch(CREATE_GAME)}
					on:touchstart|preventDefault={() => !isLoading && dispatch(CREATE_GAME)}
					disabled={isLoading}
				>
						Leave Game
				</button>
			{:else}
				<button
					type="button"
					class="cancel-button"
					title="Cancel rematch"
					on:click={() => dispatch(CANCEL_REMATCH)}
					on:touchstart|preventDefault={() => dispatch(CANCEL_REMATCH)}
				>
						Cancel
				</button>
			{/if}

			<button
				type="submit"
				class="clue-submit rematch"
				class:pulse={authPlayerClickedRematch && !isLoading}
				class:colorcycle={isLoading}
				class:highlight={numPlayersClickedRematch}
				title="Start a new game with the same teams"
				on:click={() => !isLoading && dispatch(REMATCH)}
				on:touchstart|preventDefault={() => !isLoading && dispatch(REMATCH)}
				disabled={isLoading || authPlayerClickedRematch}
			>
				{#if !authPlayerClickedRematch}
					Rematch
				{:else if isLoading}
					Starting!
				{:else}
					waiting for players...
				{/if}
			</button>

			{#if numPlayersClickedRematch}
				<div class="confirm-dialog">{numClickedRematchText}</div>
			{/if}
		{/if}
	</div>

{:else if isGuessing}
	<form class={`clue-display ${team} end-guessing`} class:timed-out={!clue.clueText} on:submit|preventDefault={() => dispatch(END_GUESSING) }>
		<span class="clue-word">
			{#if clue.clueText}
				{clue.clueText}
			{:else}
				timed out, no clue given
			{/if}
		</span>
		<span class="clue-number">{clueNumber}</span>
		<button
			class="clue-end-guessing"
			class:colorcycle={isLoading}
			title="End guessing for now"
			disabled={isLoading}
		>end turn</button>
	</form>
{:else if !showForm}
	{#if clue}
		<div class={`clue-display ${team} no-form`} class:timed-out={!clue.clueText}>
			<span class="clue-word">
				{#if clue.clueText}
					{clue.clueText}
				{:else}
					timed out, no clue given
				{/if}
			</span>
			<span class="clue-number">{clueNumber}</span>
			{#if showForceEndTurn}
				<button
					class="force-end-turn-button"
					class:fast-pulse={!isLoading}
					class:colorcycle={isLoading}
					on:click={() => dispatch(FORCE_END_TURN)}
					on:touchstart|preventDefault={() => dispatch(FORCE_END_TURN)}
				>
						END TURN
				</button>
			{/if}
		</div>
	{:else if showForceEndTurn}
		<div class={`clue-display ${team} no-form`}>
			<button
				class="force-end-turn-button"
				class:fast-pulse={!isLoading}
				class:colorcycle={isLoading}
				on:click={() => dispatch(FORCE_END_TURN)}
				on:touchstart|preventDefault={() => dispatch(FORCE_END_TURN)}
			>
					END TURN
			</button>
		</div>
	{/if}
{:else}
	<form
		class={`clue-display ${team} form`}
		on:submit|preventDefault={() => {
			if (!clueNumber) {
				clueNumberConfirmationNeeded = true;
				return false;
			}
			dispatch(GIVE_CLUE, { clueText, clueNumber });
		}}
	>
		<input
			class="clue-word"
			type="text"
			title="A single word or proper name"
			bind:value={clueText}
			placeholder="Type your clue"
			maxlength="20"
		/>

		<input
			class="clue-number"
			class:highlight={clueNumber}
			type="text"
			bind:value={clueNumber}
			title="Select cards on the board"
			maxlength="1"
			on:input={() => clueNumber = clueNumber.toString().replace(/[^0-9]+/ig, '')}
			on:keydown={(e) => clueNumber = e.key.toString().replace(/[^0-9]+/ig, '')}
			on:focus={(e) => {
				e.target.select()
			}}
		/>

		{#if !clueNumberConfirmationNeeded}
			<button
				type="submit"
				class="clue-submit"
				class:colorcycle={isLoading}
				title={!isClueDisabled ? 'Click to send your clue' : 'Type a clue and select some cards'}
				disabled={isClueDisabled}>
					Give Clue
			</button>

		{:else}
			<button
				type="submit"
				class="clue-submit confirm"
				class:colorcycle={isLoading}
				title={'Confirm ZERO'}
				on:click|preventDefault={() => {
					dispatch(GIVE_CLUE, { clueText, clueNumber });
					clueNumberConfirmationNeeded = false;
				}}
				on:touchstart|preventDefault={() => {
					dispatch(GIVE_CLUE, { clueText, clueNumber });
					clueNumberConfirmationNeeded = false;
				}}
			>
					Confirm
			</button>
			<button
				type="button"
				class="clue-submit cancel"
				class:colorcycle={isLoading}
				title={!isClueDisabled ? 'Click to send your clue' : 'Type a clue and select some cards'}
				disabled={isClueDisabled}
				on:click={() => {
					clueNumberConfirmationNeeded = false;
				}}
				on:touchstart|preventDefault={() => {
					clueNumberConfirmationNeeded = false;
				}}
			>
					Cancel
			</button>
			<div class="confirm-dialog">
				Are you sure you want to give a clue number of ZERO?
			</div>
		{/if}
	</form>

{/if}

<style lang="less">
	.clue-display {
		display: flex;
		align-items: center;
		font-size: 1.6em;

		* {
			margin: 0em 0.2em;
			text-align: center;
			font-size: 2em;
			font-weight: 700;
		}

		&.one {
			.clue-number {
				color: white;
				background: rgba(30,130,255, 1);
			}
		}

		&.two {
			.clue-number {
				color: white;
				background: rgba(255,0,204, 1);
			}
		}

		.clue-word {
			padding: 0.5em 0.9em;
		}

		.clue-number {
			display: flex;
			width: 2.2em; height: 2.2em;
			justify-content: center;
    		align-items: center;
			color: white;
			background: rgba(0, 0, 0, 0.6);
			border: 0.1em solid #ffffff;
			border-radius: 100%;

			&.highlight {
				border-color: fade(#ffff00, 100%);
				box-shadow: 0 0 0.9em #ffff00;
			}
		}

		.clue-submit {
			padding: 0.5em 0.9em;
			font-size: 1.6em;

			&.cancel {
				background: #939393;
			}
			&.confirm {
				background: #18d72e;
			}
			&.highlight {
				box-shadow: 0 0 0.9em #18d72e;
			}

			&.rematch {
				background: #18d72e;
				box-shadow: 0 0 0.9em #18d72e;
			}
		}

		.cancel-button {
			color: white;
			background: #aaaaaa;
		}

		&.end-guessing, &.no-form {
			.clue-word {
				color: black;
				background: rgba(255,255,255,0.9);
				border: 0.1em solid #969696;
				border-radius: 0.4em;
			}
			.clue-number {
				color: black;
				background: rgba(255,255,255,0.9);
				border: 0.1em solid #969696;
				border-radius: 100%;
			}
		}

		&.end-guessing {
			padding-left: 6em;

			.clue-word, .clue-number {
				color: white;
				background: #18d72e;
			}
			button {
				font-size: 1.1em;
			}
		}

		&.no-form {
			.force-end-turn-button {
				background: #ff2626;
				font-size: 1.2em;
			}
		}

		&.form {
			font-size: 1.4em;
			.clue-word {
				color: black;
				background: rgba(255, 255, 255, 0.9);
				border: 0.1em solid #313131;
			}
		}

		&.timed-out {
			.clue-word {
				padding: 1em 1.8em;
				font-size: 1.2em;
				color: white;
				background: #ff2626;
				border: 0.1em solid #ffffff;
			}
		}
	}

	.confirm-dialog {
		position: absolute;
		top: 110%; right: 0;
		padding: 0.5em;
		font-size: 1.6em;
		font-weight: 500;
		border: 0.1em solid white;
		border-radius: 0.5em;
		background: #18d72e;
		color: white;
		z-index: 2;
	}
</style>